import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import * as youbora from "youboralib";
import ReactGtag from "utils/ReactGtag";
import ReactTapfiliate from "utils/ReactTapfiliate";
import ReactBeamer from "utils/ReactBeamer";
import ReactTikTok from "utils/ReactTiktok";

const Tracker = {
  trackers: {
    global_site_tag: {
      initialized: false,
      id: null,
      event_queue: [],
    },
    google_analytics: {
      initialized: false,
      event_queue: [],
    },
    facebook_pixel: {
      initialized: false,
      event_queue: [],
    },
    tapfiliate: {
      initialized: false,
      id: null,
      event_queue: [],
    },
    beamer: {
      initialized: false,
      id: null,
    },
    tiktok_pixel: {
      initialized: false,
      id: null,
      event_queue: [],
    },
  },
  youbora: null,
};

Tracker.events = {
  TRACK_INITIATE_CHECKOUT: "track_initiate_checkout",
  TRACK_VIEW_CONTENT: "track_view_content",
  TRACK_ADD_TO_CART: "track_add_to_cart",
  TRACK_ADD_GIFT_TO_CART: "track_add_gift_to_cart",
  TRACK_COMPLETE_REGISTRATION: "track_complete_registration",
  TRACK_ADD_PAYMENT_INFO: "track_add_payment_info",
  TRACK_PURCHASE: "track_purchase",
  TRACK_LEAD: "track_lead",
  TRACK_PAGE_VIEW: "track_page_view",
};

Tracker.tiktokEvents = {
  track_initiate_checkout: "StartCheckout",
  track_add_to_cart: "AddToCart",
  track_complete_registration: "Registration",
  track_add_payment_info: "AddBilling",
  track_purchase: "Purchase",
  track_page_view: "Browse",
};

Tracker.pages = {
  homepage: "HomePage",
  contents: "ContentsPage",
  content: "ContentPage",
  smartlist: "SmartlistPage",
  smartlists: "SmartlistsPage",
  search: "SearchPage",
  subscribe: "SubscribePage",
  login: "LoginPage",
  profile: "ProfilePage",
  myvideos: "MyvideosPage",
  playlist: "PlaylistPage",
  series: "SeriesPage",
  season: "SeasonPage",
  my_list: "My_listPage",
  my_playlists: "MyPlaylistsPage",
  my_playlist: "MyPlaylistPage",
  casting: "CastingPage",
};

const sendGaEvent = (eventName) => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.event({
    category: "Navigation",
    action: eventName,
  });
};

const sendGtagEvent = (eventName, options) => {
  ReactGtag.sendEvent(eventName, options || {});
};

const sendFbEvent = (eventName, options) => {
  ReactPixel.trackCustom(eventName, options || {});
};

const sendTapfiliateEvent = (eventName, options) => {
  ReactTapfiliate.sendEvent(
    Tracker.trackers.tapfiliate.id,
    eventName,
    options || {},
  );
};

const sendGaPageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

const sendGtagPageView = () => {
  ReactGtag.sendPageView(window.location.pathname + window.location.search);
};

const sendFbPageView = () => {
  ReactPixel.pageView();
};

const sendTiktokEvent = (eventName, options) => {
  ReactTikTok.sendEvent(Tracker.tiktokEvents[eventName], options || {});
};

const sendTiktokPageView = () => {
  ReactTikTok.sendPageView(window.location.pathname + window.location.search);
};

const sendYouboraPageView = (location) => {
  if (!location) return;

  const pageArray = location.pathname.split("/");
  const pageId =
    pageArray && pageArray.length > 0 && pageArray[1].length > 0
      ? pageArray[1]
      : "homepage";

  Tracker.trackers.youbora.infinity.fireNav({
    route: window.location + location.pathname,
    page: Tracker.pages[pageId] ? Tracker.pages[pageId] : "UnknownPage",
  });
};

Tracker.initialize = (trakers, enableYoubora) => {
  trakers &&
    trakers.forEach((traker) => {
      switch (traker.type) {
        case "global_site_tag":
          ReactGtag.initialize(traker.config.id);
          Tracker.trackers = {
            ...Tracker.trackers,
            global_site_tag: {
              ...Tracker.trackers.global_site_tag,
              initialized: true,
              id: traker.config.id,
            },
          };
          if (Tracker.trackers.global_site_tag.event_queue.length > 0) {
            Tracker.trackers.global_site_tag.event_queue.forEach((event) => {
              switch (event.type) {
                case "event":
                  sendGtagEvent(event.eventName, event.options);
                  break;
                case "pageView":
                  sendGtagPageView();
                  break;
              }
            });
          }
          break;
        case "google_analytics":
          ReactGA.initialize(traker.config.id);
          Tracker.trackers = {
            ...Tracker.trackers,
            google_analytics: {
              ...Tracker.trackers.google_analytics,
              initialized: true,
            },
          };
          if (Tracker.trackers.google_analytics.event_queue.length > 0) {
            Tracker.trackers.google_analytics.event_queue.forEach((event) => {
              switch (event.type) {
                case "event":
                  sendGaEvent(event.eventName);
                  break;
                case "pageView":
                  sendGaPageView();
                  break;
              }
            });
          }
          break;
        case "facebook_pixel":
          ReactPixel.init(traker.config.id);
          Tracker.trackers = {
            ...Tracker.trackers,
            facebook_pixel: {
              ...Tracker.trackers.facebook_pixel,
              initialized: true,
            },
          };
          if (Tracker.trackers.facebook_pixel.event_queue.length > 0) {
            Tracker.trackers.facebook_pixel.event_queue.forEach((event) => {
              switch (event.type) {
                case "event":
                  sendFbEvent(event.eventName, event.options);
                  break;
                case "pageView":
                  sendFbPageView();
                  break;
              }
            });
          }
          break;
        case "tiktok_pixel":
          ReactTikTok.initialize(traker.config.id);
          Tracker.trackers = {
            ...Tracker.trackers,
            tiktok_pixel: {
              ...Tracker.trackers.tiktok_pixel,
              initialized: true,
            },
          };
          if (Tracker.trackers.tiktok_pixel.event_queue.length > 0) {
            Tracker.trackers.tiktok_pixel.event_queue.forEach((event) => {
              switch (event.type) {
                case "event":
                  sendTiktokEvent(event.eventName, event.options);
                  break;
                case "pageView":
                  sendTiktokPageView();
                  break;
              }
            });
          }
          break;
        case "tapfiliate":
          ReactTapfiliate.initialize(traker.config.id).then(() => {
            Tracker.trackers = {
              ...Tracker.trackers,
              tapfiliate: {
                ...Tracker.trackers.tapfiliate,
                initialized: true,
                id: traker.config.id,
              },
            };
            if (Tracker.trackers.tapfiliate.event_queue.length > 0) {
              Tracker.trackers.tapfiliate.event_queue.forEach((event) => {
                switch (event.type) {
                  case "event":
                    sendTapfiliateEvent(event.eventName, event.options);
                    break;
                }
              });
            }
          });
          break;
        case "beamer":
          ReactBeamer.initialize(traker.config.id).then(() => {
            Tracker.trackers = {
              ...Tracker.trackers,
              beamer: {
                ...Tracker.trackers.beamer,
                id: traker.config.id,
                initialized: true,
              },
            };
          });
          break;
      }
    });

  if (enableYoubora && youbora) {
    Tracker.trackers = {
      ...Tracker.trackers,
      youbora: new youbora.Plugin({
        accountCode: "okast",
        "session.context": true,
      }),
    };
  }
};

Tracker.sendTrackingEvent = (eventName) => {
  Object.keys(Tracker.trackers).forEach((traker) => {
    switch (traker) {
      case "global_site_tag":
        if (Tracker.trackers.global_site_tag.initialized) {
          sendGtagEvent(eventName);
        } else {
          Tracker.trackers.global_site_tag.event_queue.push({
            type: "event",
            eventName,
          });
        }
        break;
      case "google_analytics":
        if (Tracker.trackers.google_analytics.initialized) {
          sendGaEvent(eventName);
        } else {
          Tracker.trackers.google_analytics.event_queue.push({
            type: "event",
            eventName,
          });
        }
        break;
      case "facebook_pixel":
        if (Tracker.trackers.facebook_pixel.initialized) {
          sendFbEvent(eventName);
        } else {
          Tracker.trackers.facebook_pixel.event_queue.push({
            type: "event",
            eventName,
          });
        }
        break;
      case "tiktok_pixel":
        if (Tracker.trackers.tiktok_pixel.initialized) {
          sendTiktokEvent(eventName);
        } else {
          Tracker.trackers.tiktok_pixel.event_queue.push({
            type: "event",
            eventName,
          });
        }
        break;
      default:
    }
  });
};

Tracker.sendConversion = (customerId, amount, currency, coupon) => {
  let eventName = null;
  let options = null;
  Object.keys(Tracker.trackers).forEach((traker) => {
    switch (traker) {
      case "global_site_tag":
        eventName = "conversion";
        options = {
          send_to: `${Tracker.trackers.global_site_tag.id}/purchase_conversion`,
          value: amount,
          currency,
        };
        if (Tracker.trackers.global_site_tag.initialized) {
          sendGtagEvent(eventName, options);
        } else {
          Tracker.trackers.global_site_tag.event_queue.push({
            type: "event",
            eventName,
            options,
          });
        }
        break;
      case "facebook_pixel":
        eventName = "Purchase";
        options = {
          value: amount,
          currency,
        };
        if (Tracker.trackers.facebook_pixel.initialized) {
          sendFbEvent(eventName, options);
        } else {
          Tracker.trackers.facebook_pixel.event_queue.push({
            type: "event",
            eventName,
            options,
          });
        }
        break;
      case "tapfiliate":
        eventName = "conversion";
        options = {
          customerId,
          amount,
          currency,
          coupons: coupon,
        };
        if (Tracker.trackers.tapfiliate.initialized) {
          sendTapfiliateEvent(eventName, options);
        } else {
          Tracker.trackers.tapfiliate.event_queue.push({
            type: "event",
            eventName,
            options,
          });
        }
        break;
      default:
    }
  });
};

Tracker.sendPageView = (location) => {
  Object.keys(Tracker.trackers).forEach((traker) => {
    switch (traker) {
      case "global_site_tag":
        if (Tracker.trackers.global_site_tag.initialized) {
          sendGtagPageView();
        } else {
          Tracker.trackers.global_site_tag.event_queue.push({
            type: "pageView",
          });
        }
        break;
      case "google_analytics":
        if (Tracker.trackers.google_analytics.initialized) {
          sendGaPageView();
        } else {
          Tracker.trackers.google_analytics.event_queue.push({
            type: "pageView",
          });
        }
        break;
      case "facebook_pixel":
        if (Tracker.trackers.facebook_pixel.initialized) {
          sendFbPageView();
        } else {
          Tracker.trackers.facebook_pixel.event_queue.push({
            type: "pageView",
          });
        }
        break;
      case "tiktok_pixel":
        if (Tracker.trackers.tiktok_pixel.initialized) {
          sendTiktokPageView();
        } else {
          Tracker.trackers.tiktok_pixel.event_queue.push({
            type: "pageView",
          });
        }
        break;
      case "youbora":
        if (Tracker.trackers.youbora) {
          sendYouboraPageView(location);
        }
        break;
      default:
    }
  });
};

Tracker.startYouboraSession = (projectUuid, email, orgaUuid) => {
  if (Tracker.trackers.youbora) {
    Tracker.trackers.youbora.setOptions({
      "content.customDimension.1": projectUuid,
      "content.customDimension.2": orgaUuid,
      username: email || "unknown",
    });
    Tracker.trackers.youbora.infinity.newSession();
  }
};
export default Tracker;
